import { useMemo } from "react";

import { getDefaultValuesTerminalSolution } from "queries";

type TerminalDefaultParams = {
	terminalList: any;
	isLoadingTerminalList: boolean;
	applicationProcessor: string;
	terminalAccessoryTypes?: any;
};

export const useTerminalSolutionDefaultValues = () => {
	const useDefaultValueForPointOfSale = ({
		terminalList,
		isLoadingTerminalList,
		applicationProcessor,
	}: TerminalDefaultParams) =>
		useMemo(() => {
			if (!isLoadingTerminalList) {
				const pointOfSale = terminalList?.items?.filter(
					(item: { [key: string]: any }) => !!item?.point_of_sale,
				);

				return getDefaultValuesTerminalSolution({
					data: pointOfSale?.[0],
					applicationProcessor,
				});
			}
		}, [applicationProcessor, isLoadingTerminalList, terminalList]);

	const useDefaultValueForGateway = ({
		terminalList,
		isLoadingTerminalList,
		applicationProcessor,
	}: TerminalDefaultParams) =>
		useMemo(() => {
			if (!isLoadingTerminalList) {
				const gateway = terminalList?.items?.filter(
					(item: { [key: string]: any }) => !!item?.gateway,
				);

				const values = getDefaultValuesTerminalSolution({
					data: gateway?.[0],
					applicationProcessor,
				});

				return values;
			}
		}, [applicationProcessor, isLoadingTerminalList, terminalList?.items]);

	const useDefaultValueForTerminals = ({
		terminalList,
		isLoadingTerminalList,
		applicationProcessor,
		terminalAccessoryTypes,
	}: TerminalDefaultParams) =>
		useMemo(() => {
			if (!isLoadingTerminalList) {
				const terminals = terminalList?.items?.filter(
					(item: { [key: string]: any }) => !!item?.terminal,
				);

				const values = terminals?.map(terminal =>
					getDefaultValuesTerminalSolution({
						data: terminal,
						terminalAccessoryTypes,
						applicationProcessor,
					}),
				);

				return values;
			}
		}, [
			applicationProcessor,
			isLoadingTerminalList,
			terminalAccessoryTypes,
			terminalList?.items,
		]);

	return {
		useDefaultValueForPointOfSale,
		useDefaultValueForGateway,
		useDefaultValueForTerminals,
	};
};
